<aside class="left" (click)="onAccountClicked()">
  <ds-lib-hover color="menu"></ds-lib-hover>
  <mat-icon class="user-icon">person_outline</mat-icon>
  <div class="infos-container" *ngIf="isExpanded">
    <p class="name">{{ mainInfo }}</p>
    <p class="role">{{ subInfo }}</p>
  </div>
</aside>
